import { Component } from '@angular/core';

@Component({
  selector: 'app-enlaces-legales',
  templateUrl: './enlaces-legales.component.html',
  styleUrls: ['./enlaces-legales.component.scss'],
  standalone: false,
})
export class EnlacesLegalesComponent {}
